import { fbaHooks } from '@flatbiz/antd';

export const [usePageWrapperCtx, PageWrapperCtxProvider] = fbaHooks.createCtx<{
  onReload: () => void;
  onRefresh: () => void;
}>();
